const translations = {
  common: {
    showing: "Showing",
    rowsPerPage: "Rows per page",
    page: "Page",
    firstPage: "First page",
    previousPage: "Previous page",
    nextPage: "Next page",
    lastPage: "Last page",
    loading: "Loading...",
    typing: "Typing",
    retry: "Retry",
    save: "Save",
    saving: "Saving...",
    cancel: "Cancel",
    delete: "Delete",
    deleting: "Deleting...",
    reset: "Reset Filters",
    apply: "Apply Filters",
    back: "Back",
    all: "All",
    yes: "Yes",
    no: "No",
    confirm: "Confirm",
    view: "View",
    edit: "Edit",
    of: "of",
    change: "Change",
    remove: "Remove",
    rowsSelected: "row(s) selected",
    goToFirstPage: "Go to first page",
    goToPreviousPage: "Go to previous page",
    goToNextPage: "Go to next page",
    goToLastPage: "Go to last page",
    notSpecified: "Not specified",
    logout: "Logout",
    premium: "Premium",
    account: "Account",
    payment: "Payment",
    notifications: "Notifications",
    lightTheme: "Light Theme",
    darkTheme: "Dark Theme",
    language: "Language",
    ukrainian: "Ukrainian",
    english: "English",
    errors: {
      loading: "Error loading data",
      tryAgain: "Please try again later",
      notFound: "Data not found",
      invalidParams: "Invalid parameters",
      missingParams: "Missing required parameters",
      missingPropertyId: "Missing property ID",
      forbidden: "Forbidden",
      occurred: "An error occurred",
      tryAgainOrContact:
        "Please try again later or contact support if the problem persists.",
    },
    noData: {
      title: "No Data Available",
      description: "No records found for the selected filters",
      hint: "Try changing your search criteria or filters",
    },
    userTooltip: {
      email: "Email",
      phone: "Phone",
      role: "Role",
      status: "Status",
      registeredAt: "Registered",
      lastUpdated: "Updated",
      noUser: "No User",
      userRemoved: "User has been removed",
    },
    tableSettings: {
      title: "Table Settings",
      description: "Customize table display",
      containerMode: {
        title: "Container Mode",
        description: "Limits table width and centers it on the page",
      },
      save: "Save",
      cancel: "Cancel",
    },
    viewOptions: {
      title: "Columns",
      label: "Column Visibility",
    },
    assigning: "Assigning...",
    properties: "Properties",
    share: "Share",
    success: "Success",
    error: "Error",
    currency: "UAH",
    actions: {
      add: "Add New",
      edit: "Edit",
      delete: "Delete",
      view: "View",
      cancel: "Cancel",
      confirm: "Confirm",
    },
    select: {
      search: "Search",
      noResults: "No results found",
      noMoreResults: "No more results found",
      loading: "Loading...",
      clear: "Clear",
      selectAll: "Select All",
      select: "Select",
      noOptions: "No options found",
      create: "Create",
      edit: "Edit",
      delete: "Delete",
      cancel: "Cancel",
      confirm: "Confirm",
    },
  },
  navigation: {
    home: "Home",
    profile: "Profile",
    properties: "Properties",
    "properties.all": "All Properties",
    "properties.new": "Add Property",
    "properties.complex": "Residential Complex",
    "properties.commercial": "Commercial Property",
    "properties.houses": "Private Houses",
    documents: "Documents",
    "documents.all": "All Documents",
    "documents.new": "Create",
    "documents.archive": "Archive",
    payments: "Payments",
    requests: "Requests",
    chat: "Chat",
    notifications: "Notifications",
    settings: "Settings",
    "settings.general": "General",
    "settings.profile": "Profile",
    "settings.security": "Security",
    admin: "Admin Panel",
    support: "Support",
    feedback: "Feedback",
    "projects.complex": "Residential Complex",
    "projects.commercial": "Commercial Property",
    "projects.houses": "Private Houses",
    leases: "Leases",
    reports: "Reports",
    security: "Security",
    users: "Users",
  },
  App: {
    hello: "Hello, world!",
    healthCheck: "Health check: ",
  },
  AuthSocial: {
    googleLogin: "Login with Google",
    toast: {
      successTitle: "Google Sign In Successful",
      successDescription: "Welcome to the system",
      errorTitle: "Google Sign In Error",
      errorDescription: "Failed to sign in with Google. Please try again.",
    },
  },
  LoginForm: {
    title: "Login",
    description: "Enter your email to sign in to your account",
    headerTitle: "Login to your account",
    headerDescription: "Enter your email below to login to your account",
    email: "Email",
    password: "Password",
    forgotPassword: "Forgot password?",
    loginButton: "Sign in",
    loginLoading: "Signing in...",
    noAccount: "Don't have an account?",
    register: "Register",
    validation: {
      invalidEmail: "Invalid email format",
      passwordLength: "Password must be at least 6 characters",
    },
    toast: {
      successTitle: "Login Successful",
      successDescription: "Welcome to the system",
      errorTitle: "Login Error",
      errorDescription: "Please check your credentials and try again",
    },
  },
  RegisterForm: {
    title: "Registration",
    description: "Create a new account to access the system",
    headerTitle: "Create your account",
    headerDescription: "Fill in the information below to create your account",
    email: "Email",
    password: "Password",
    role: "Role",
    selectRole: "Select your role",
    registerButton: "Register",
    registerLoading: "Registering...",
    haveAccount: "Already have an account?",
    login: "Login",
    validation: {
      invalidEmail: "Invalid email format",
      passwordLength: "Password must be at least 6 characters",
      roleRequired: "Role is required",
    },
    toast: {
      successTitle: "Registration Successful",
      successDescription: "Now you can log in to the system",
      errorTitle: "Registration Error",
      errorDescription: "Please check your data and try again",
    },
  },
  ForgotPasswordForm: {
    title: "Forgot Password",
    description: "Enter your email to reset your password",
    headerTitle: "Reset your password",
    headerDescription:
      "Enter your email below and we will send you a link to reset your password",
    email: "Email",
    resetButton: "Send Reset Link",
    resetLoading: "Sending...",
    backToLogin: "Back to Login",
    validation: {
      invalidEmail: "Invalid email format",
    },
    toast: {
      successTitle: "Reset Link Sent",
      successDescription: "Please check your email for the reset link",
      errorTitle: "Error",
      errorDescription:
        "There was an error sending the reset link. Please try again.",
    },
  },
  ResetPasswordForm: {
    title: "Reset Password",
    description: "Enter a new password for your account",
    headerTitle: "Create New Password",
    headerDescription: "Please enter a new secure password for your account",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    resetButton: "Reset Password",
    resetLoading: "Resetting password...",
    validation: {
      passwordMinLength: "Password must be at least 8 characters long",
      passwordUppercase: "Password must contain at least one uppercase letter",
      passwordLowercase: "Password must contain at least one lowercase letter",
      passwordNumber: "Password must contain at least one number",
      passwordSpecial: "Password must contain at least one special character",
      passwordsMatch: "Passwords must match"
    },
    toast: {
      successTitle: "Success!",
      successDescription: "Your password has been successfully reset. You can now log in with your new password.",
      errorTitle: "Error!",
      errorDescription: "Failed to reset password. Please try again."
    }
  },
  users: {
    title: "Users",
    description: "System users management",
    actions: {
      addUser: "Add User",
      open: "Open actions menu",
      edit: "Edit",
      delete: "Delete",
      changeRole: "Change Role",
      changeStatus: "Change Status",
      activate: "Activate",
      deactivate: "Deactivate",
    },
    stats: {
      total: "Total Users",
      active: "Active",
      pending: "Pending Confirmation",
      inactive: "Inactive",
    },
    filters: {
      search: "Search users...",
      role: {
        label: "Role",
        all: "All roles",
      },
      status: {
        label: "Status",
        all: "All statuses",
      },
    },
    columns: {
      user: "User",
      role: "Role",
      status: "Status",
      isActive: "Activity",
      createdAt: "Registration Date",
      initials: "US",
      actions: "Actions",
    },
    noData: {
      title: "No Data",
      description: "No users found",
    },
    errors: {
      loadingError: "Error loading data. Please try again later.",
      insufficientPermissions:
        "Insufficient permissions to perform this action.",
      userNotFound: "User not found.",
      validationError: "Data validation error.",
    },
    delete: {
      title: "Delete User",
      description:
        "Are you sure you want to delete this user? This action cannot be undone.",
      setInactiveDescription:
        "This action will set the user status to Inactive. The user's data will be preserved but they won't be able to log in.",
      confirm: "Delete",
      confirmInactive: "Set Inactive",
      confirmHard: "Delete Permanently",
      cancel: "Cancel",
      hardDelete: "Hard delete",
      hardDeleteWarning: "Hard delete will permanently remove all user data from the system. This action cannot be undone.",
    },
    toast: {
      deleteSuccess: {
        title: "Successfully Deleted",
        description: "User has been successfully deleted",
      },
      hardDeleteSuccess: {
        title: "Successfully Deleted",
        description: "User has been permanently deleted from the system",
      },
      deleteError: {
        title: "Delete Error",
        description: "Failed to delete user. Please try again.",
      },
      statusChangeSuccess: {
        title: "Status Changed",
        description: "User status has been successfully changed",
      },
      inactiveSuccess: {
        title: "User Deactivated",
        description: "User has been set to Inactive status",
      },
      statusChangeError: {
        title: "Status Change Error",
        description: "Failed to change user status. Please try again.",
      },
      updateSuccess: {
        title: "Successfully Updated",
        description: "User data has been successfully updated",
      },
      updateError: {
        title: "Update Error",
        description: "Failed to update user data. Please try again.",
      },
      roleUpdateSuccess: {
        title: "Role Updated",
        description: "User role has been successfully changed",
      },
      statusUpdateSuccess: {
        title: "Status Updated",
        description: "User status has been successfully changed",
      },
      activateSuccess: {
        title: "User Activated",
        description: "User has been successfully activated",
      },
      deactivateSuccess: {
        title: "User Deactivated",
        description: "User has been successfully deactivated",
      },
      createSuccess: {
        title: "Successfully Created",
        description: "New user has been successfully created",
      },
      createError: {
        title: "Create Error",
        description: "Failed to create user. Please try again.",
      },
    },
    role: {
      title: "Change User Role",
      description: "Select a new role for the user",
      confirm: "Confirm",
      cancel: "Cancel",
      options: {
        admin: "Administrator",
        owner: "Owner",
        staff: "Staff",
        tenant: "Tenant",
        unassigned: "Unassigned",
      },
    },
    status: {
      title: "Change User Status",
      description: "Select a new status for the user",
      confirm: "Confirm",
      cancel: "Cancel",
      options: {
        active: "Active",
        pending: "Pending",
        inactive: "Inactive",
        suspended: "Suspended",
      },
    },
    activate: {
      title: "Activate User",
      description: "Are you sure you want to activate this user?",
      confirm: "Activate",
      cancel: "Cancel",
    },
    deactivate: {
      title: "Deactivate User",
      description: "Are you sure you want to deactivate this user?",
      confirm: "Deactivate",
      cancel: "Cancel",
    },
    dialog: {
      create: {
        title: "Create New User",
        description: "Enter the details for the new user",
        submit: "Create User",
        loading: "Creating...",
      },
    },
    form: {
      email: "Email",
      password: "Password",
      confirmPassword: "Confirm Password",
      manager: "Manager",
      managerPlaceholder: "Select manager",
      validation: {
        managerRequired: "Manager is required",
      },
    },
    roles: {
      TENANT: "Tenant",
      ADMIN: "Administrator",
      OWNER: "Owner",
      STAFF: "Staff",
      UNASSIGNED: "Unassigned",
    },
    statuses: {
      ACTIVE: "Active",
      INACTIVE: "Inactive",
      PENDING: "Pending",
      SUSPENDED: "Suspended",
    },
  },
  profile: {
    title: "User Profile",
    description: "Detailed user information",
    role: "Role",
    status: "Status",
    phone: "Phone",
    birthDate: "Birth Date",
    registeredAt: "Registration Date",
    lastUpdated: "Last Updated",
    errors: {
      loadingError: "Error loading user data. Please try again later.",
    },
    image: {
      upload: {
        aria: "Upload profile image",
      },
      toast: {
        success: {
          title: "Image Updated",
          description: "Your profile image has been successfully updated",
        },
        error: {
          title: "Error",
          description: "Failed to update profile image",
          sizeLimit: "Image size must not exceed 5MB",
          invalidType: "Only JPG, JPEG, PNG, GIF and WebP images are allowed",
        },
      },
    },
    toast: {
      success: {
        title: "Profile Updated",
        description: "Your profile has been successfully updated",
        emailChanged: "Your email has been changed. Please verify your new email address.",
        phoneChanged: "Your phone number has been changed. Please verify your new phone number.",
        phoneRemoved: "Your phone number has been successfully removed"
      },
      error: {
        title: "Update Error",
        description: "Failed to update profile. Please try again.",
        validation: {
          firstName: "First name must be at least 2 characters",
          lastName: "Last name must be at least 2 characters",
          email: "Invalid email format",
          phoneNumber: "Invalid phone number format",
        },
      },
    },
  },
  validation: {
    isRequired: "is required",
    email: "Invalid email format",
    minLength: "{{field}} must be at least {{length}} characters",
    maxLength: "{{field}} must be at most {{length}} characters",
  },
  settings: {
    title: "Settings",
    description: "Manage your account and system settings",
    tabs: {
      profile: "Profile",
      general: "General",
      notifications: "Notifications",
      security: "Security",
      audit: "Audit Log",
    },
    auditLogs: {
      title: "Audit Logs",
      description: "View user activity history",
      details: {
        title: "Activity Details",
        oldValue: "Old Value",
        newValue: "New Value",
        showCode: "Show Code",
        noData: "No data",
        viewChanges: "View Changes",
      },
      delete: {
        title: "Delete Record",
        description:
          "Are you sure you want to delete this record? This action cannot be undone.",
      },
      toast: {
        deleteSuccess: {
          title: "Successfully Deleted",
          description: "Record has been successfully deleted",
        },
        deleteError: {
          title: "Delete Error",
          description: "Failed to delete record. Please try again.",
        },
      },
      fields: {
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        phoneNumber: "Phone Number",
        birthDate: "Birth Date",
        avatarData: "Profile Image",
        theme: "Theme",
        role: "Role",
        status: "Status",
        isActive: "Activity Status",
        password: "Password",
        emailVerified: "Email Verification",
        phoneVerified: "Phone Verification",
        pushEnabled: "Push Notifications",
        emailEnabled: "Email Notifications",
        phoneEnabled: "Phone Notifications",
        imageGoogleUrl: "Google Profile Image",
      },
      columns: {
        action: "Action",
        ipAddress: "IP Address",
        userAgent: "Browser",
        createdAt: "Date",
        actions: "Actions",
      },
      actions: {
        UPDATE_PROFILE: "Profile Update",
        DELETE_PROFILE: "Profile Delete",
        LOGIN: "Login",
        LOGOUT: "Logout",
        CHANGE_PASSWORD: "Password Change",
        CHANGE_EMAIL: "Email Change",
        CHANGE_PHONE: "Phone Change",
        UPDATE_NOTIFICATIONS: "Notifications Update",
        UPDATE_SETTINGS: "Settings Update",
        ACTIVATE_ACCOUNT: "Account Activation",
        DEACTIVATE_ACCOUNT: "Account Deactivation",
        BLOCK_ACCOUNT: "Account Block",
        FAILED_LOGIN: "Failed Login",
        EMAIL_VERIFIED: "Email Verified",
        PHONE_VERIFIED: "Phone Verified",
        CHANGE_ROLE: "Role Change",
        delete: "Delete",
      },
    },
    profile: {
      title: "Profile",
      description: "Manage your personal information",
      form: {
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        phoneNumber: "Phone Number",
        birthDate: "Birth Date",
        selectDate: "Select date",
        submit: "Save changes",
      },
      toast: {
        success: {
          title: "Profile Updated",
          description: "Your profile has been successfully updated",
        },
        error: {
          title: "Error",
          description: "Failed to update profile",
        },
      },
    },
    verification: {
      title: "Verification",
      description: "Verify your email and phone number",
      email: "Email",
      phone: "Phone Number",
      verified: "Verified",
      send: "Send Code",
      verify: "Verify",
      code: {
        sent: {
          title: "Verification Code Sent",
          description: {
            email: "Check your email",
            phone: "Check your SMS messages",
          },
        },
        error: {
          title: "Error",
          description: "Failed to send verification code",
        },
      },
      dialog: {
        title: "Enter Verification Code",
        description: {
          email: "Enter the 6-digit code we sent to your email",
          phone: "Enter the 6-digit code we sent via SMS",
        },
        placeholder: "Enter code",
      },
      success: {
        title: "Verification Complete",
        description: {
          email: "Your email has been verified",
          phone: "Your phone number has been verified",
        },
      },
      error: {
        title: "Error",
        description: "Invalid verification code",
      },
    },
    notifications: {
      title: "Notifications",
      description: "Manage your notification preferences",
      push: {
        title: "Push Notifications",
        description: "Get instant notifications in your browser",
      },
      email: {
        title: "Email Notifications",
        description: "Receive important updates via email",
      },
      phone: {
        title: "Phone Notifications",
        description: "Receive notifications via SMS",
      },
      update: {
        success: "Notification settings updated successfully",
        error: "Failed to update notification settings",
      },
      phoneEnabled: "Phone Notifications",
      emailEnabled: "Email Notifications",
      pushEnabled: "Push Notifications",
    },
    interface: {
      title: "Interface",
      description: "Customize the appearance and language",
      theme: {
        title: "Theme",
        description: "Choose your preferred theme",
        options: {
          light: "Light",
          dark: "Dark",
          system: "System",
        },
        success: {
          title: "Theme Updated",
          description: "Your theme preferences have been saved"
        },
        error: {
          title: "Theme Update Failed",
          description: "Failed to update theme preferences"
        }
      },
      language: {
        title: "Language",
        description: "Choose your preferred language",
        options: {
          uk: "Ukrainian",
          en: "English",
        },
      },
      currency: {
        title: "Currency",
        description: "Choose your primary currency",
        options: {
          UAH: "Ukrainian Hryvnia",
          USD: "US Dollar",
          EUR: "Euro",
        },
      },
    },
    update: {
      success: "Success",
      error: "Error",
      theme: {
        success: "Theme has been successfully updated",
        error: "Failed to update theme",
      },
    },
    deleteAccount: {
      title: "Delete Account",
      description: "Permanently delete your account",
      warning: "This action cannot be undone. Once you delete your account, all of your data will be permanently removed from our servers.",
      action: "Delete Account",
      deleting: "Deleting Account...",
      confirm: {
        title: "Are you sure?",
        description: "This action is irreversible. Your account and all associated data will be permanently deleted.",
        cancel: "Cancel",
        action: "Yes, Delete Account"
      },
      toast: {
        success: {
          title: "Account Deleted",
          description: "Your account has been successfully deleted."
        },
        error: {
          title: "Error",
          description: "Failed to delete your account. Please try again later."
        }
      }
    },
  },
  properties: {
    title: "Properties",
    description: "Property management system",
    location: {
      title: "Location Information",
      country: "Country",
      countryPlaceholder: "Select country",
      postalCode: "Postal Code",
      postalCodePlaceholder: "Enter postal code",
      city: "City",
      state: "State",
      coordinates: "Coordinates",
      map: "Map",
      centerOnMarker: "Center on marker",
      property: "Property",
      copyLink: "Copy link",
      apply: "Apply",
      applied: "Applied",
      foundInfo: "Location Information Found",
      latitude: "Latitude",
      longitude: "Longitude",
      search: "Search",
      searchError: {
        title: "Search Error",
        description: "Error searching for location",
        missingFields: "Please enter postal code to search",
        notFound: "Location not found for the provided postal code",
      },
      searching: "Searching for location...",
      searchCancelled: {
        title: "Search Cancelled",
        description: "Location search has been cancelled",
      },
      updateFromAddress: "Update coordinates from address",
      yourLocation: "Your Location",
      accuracy: "Accuracy",
      meters: "meters",
      locationFound: "Location Found",
      locationFoundDesc: "Your current location has been found",
      locationError: "Location Error",
      findMyLocation: "Find my location",
      openInGoogleMaps: "Open in Google Maps",
      zoomIn: "Zoom in",
      zoomOut: "Zoom out",
      noCoordinates: "No coordinates specified",
      markerMoved: "Marker moved",
      coordinatesUpdated: "Coordinates have been updated",
      dragMarkerHint: "Drag to adjust position",
      dragMarker: "Drag the marker to set the exact location",
      mapStylesDisabledInEditMode: "Map styles are disabled in edit mode",
      mapStyles: {
        standard: "Standard",
        satellite: "Satellite",
        transport: "Transport",
        dark: "Dark",
      },
      applySuccess: {
        title: "Location Updated",
        description: "Location coordinates have been updated",
      },
      centerMap: "Center map on marker",
      findMarker: "Find marker",
      approximateLocation: "Approximate location",
    },
    errors: {
      deleteError: "Failed to delete property",
      notFound: "Property not found",
      updateError: "Failed to update property",
      uploadError: "Failed to upload images",
      deleteImageError: "Failed to delete image",
      deleteAllImagesError: "Failed to delete all images",
      reorderError: "Failed to reorder images",
      removeManagerError: "Failed to remove manager",
      assignOwnerError: "Failed to assign owner",
      removeOwnerError: "Failed to remove owner",
      loadManagersError: "Error loading managers list",
      loadOwnersError: "Error loading owners list",
      noManagersAvailable: "No managers available",
    },
    success: {
      created: "Property created successfully",
      updated: "Property updated successfully",
      deleted: "Property deleted successfully",
      statusChanged: "Property status changed successfully",
      managerAssigned: "Manager assigned successfully",
      ownerAssigned: "Owner assigned successfully",
      managerRemoved: "Manager removed successfully",
      ownerRemoved: "Owner removed successfully",
      imagesUploaded: "Images uploaded successfully",
      imageDeleted: "Image deleted successfully",
      imagesReordered: "Images reordered successfully",
      imagesDeleted: "All images have been successfully deleted",
    },
    actions: {
      edit: "Edit property",
      addProperty: "Add Property",
      open: "Open actions menu",
      delete: "Delete property",
      uploadImages: "Upload images",
      manageImages: "Manage images",
      assignOwner: "Assign owner",
    },
    noData: {
      title: "No Properties Found",
      description:
        "You don't have any properties yet. Add your first property to start managing your real estate.",
      hint: "You can also use the filters above to find hidden properties",
    },
    sections: {
      mainInfo: "Main Information",
      location: "Location",
      details: "Property Details",
      images: "Images",
    },
    tabs: {
      overview: "Overview",
      leases: "Leases",
      documents: "Documents",
      "service-requests": "Service Requests"
    },
    details: {
      noManager: "No manager assigned",
      noOwner: "No owner assigned",
      dates: "Dates",
      created: "Created",
      updated: "Updated",
      statusChanged: "Status Changed",
      features: "Features",
      contacts: "Contacts",
      owner: "Property Owner",
      manager: "Property Manager",
      price: "Price",
      address: "Address",
      createdAt: "Created",
      managerAssigned: "Manager assigned successfully",
      managerAssignedDesc: "Property manager has been updated",
      managerRemoved: "Manager removed successfully",
      managerRemovedDesc: "Property manager has been removed",
      managerRemoveFailed: "Failed to remove manager",
      ownerAssigned: "Owner assigned successfully",
      ownerAssignedDesc: "Property owner has been updated",
      ownerAssignFailed: "Failed to assign owner",
      ownerRemoved: "Owner removed successfully",
      ownerRemovedDesc: "Property owner has been removed",
      ownerRemoveFailed: "Failed to remove owner",
    },
    form: {
      name: "Property Name",
      namePlaceholder: "Enter property name",
      description: "Description",
      descriptionPlaceholder: "Enter property description",
      type: "Property Type",
      typePlaceholder: "Select property type",
      status: "Status",
      statusPlaceholder: "Select status",
      price: "Price (USD)",
      pricePlaceholder: "Enter price",
      city: "City",
      state: "State",
      area: "Area",
      areaPlaceholder: "Enter area",
      areaUnit: {
        SQUARE_FEET: "sq ft",
        SQUARE_METERS: "sq m",
      },
      address: "Address",
      addressPlaceholder: "Enter address",
      stateAbbreviation: "State Code",
      stateAbbreviationPlaceholder: "Enter state code",
      country: "Country",
      countryPlaceholder: "Enter country",
      countryAbbreviation: "Country Code",
      countryAbbreviationPlaceholder: "Enter country code",
      postalCode: "Zip Code",
      postalCodePlaceholder: "Enter zip code",
      rooms: "Rooms",
      roomsPlaceholder: "Enter number of rooms",
      bathrooms: "Bathrooms",
      bathroomsPlaceholder: "Enter number of bathrooms",
      floor: "Floor",
      floorPlaceholder: "Enter floor number",
      totalFloors: "Total Floors",
      totalFloorsPlaceholder: "Enter total floors",
      manager: "Manager",
      managerPlaceholder: "Select manager",
      cityPlaceholder: "Enter city",
      statePlaceholder: "Enter state",
      ownerPlaceholder: "Select owner",
      features: {
        title: "Features",
        addFeature: "Add feature",
        searchFeatures: "Search features",
        noFeatures: "No features found",
        noFeaturesAdded: "No features added yet",
        featuresPlaceholder: "Add feature...",
        predefined: {
          parking: "Parking",
          swimmingPool: "Swimming Pool",
          garden: "Garden",
          gym: "Gym",
          securitySystem: "Security System",
          airConditioning: "Air Conditioning",
          heating: "Heating",
          elevator: "Elevator",
          balcony: "Balcony",
          storage: "Storage",
          petFriendly: "Pet Friendly",
          furnished: "Furnished",
          smartHome: "Smart Home",
          highSpeedInternet: "High Speed Internet",
          laundry: "Laundry",
        },
      },
      validation: {
        nameRequired: "Property name is required",
        typeRequired: "Property type is required",
        priceRequired: "Price is required",
        priceMin: "Price must be greater than 0",
        statusRequired: "Status is required",
        managerRequired: "Manager is required",
        invalidUUID: "Invalid identifier format",
        ownerRequired: "Owner is required",
      },
    },
    images: {
      title: "Images",
      upload: "Upload Images",
      uploading: "Uploading...",
      noImages: "No images uploaded yet",
      dragToReorder: "Drag to reorder images",
      deleteImage: "Delete image",
      deleteAllImages: "Delete all images",
      mainImage: "Main property image",
      viewFullSize: "View full size",
      noImage: "No image",
      confirmDelete: {
        title: "Delete Image",
        description:
          "Are you sure you want to delete this image? This action cannot be undone.",
        confirm: "Delete",
        cancel: "Cancel",
      },
      confirmDeleteAll: {
        title: "Delete All Images",
        description:
          "Are you sure you want to delete all images? This action cannot be undone.",
        confirm: "Delete All",
        cancel: "Cancel",
      },
      validation: {
        maxSize: "Image size must not exceed 5MB",
        allowedTypes: "Only JPG, JPEG, PNG, GIF and WebP images are allowed",
        maxCount: "Maximum 10 images allowed",
      },
      success: {
        uploaded: "Images uploaded successfully",
        deleted: "Image deleted successfully",
        allDeleted: "All images deleted successfully",
        reordered: "Images reordered successfully",
      },
      errors: {
        upload: "Error uploading images",
        delete: "Error deleting image",
        deleteAll: "Error deleting all images",
        reorder: "Error reordering images",
      },
    },
    noAddress: "No address specified",
    columns: {
      property: "Property",
      type: "Type",
      status: "Status",
      price: "Price",
      area: "Area",
      rooms: "Rooms",
      createdAt: "Created At",
      actions: "Actions",
    },
    type: {
      apartment: "Apartment",
      house: "House",
      office: "Office",
      commercial: "Commercial",
      land: "Land",
    },
    status: {
      available: "Available",
      occupied: "Occupied",
      sold: "Sold",
      pending: "Pending",
      maintenance: "Maintenance",
    },
    filters: {
      title: "Filters",
      searchPlaceholder: "Enter keywords...",
      search: "Search",
      type: "Property Type",
      allTypes: "All Types",
      status: "Status",
      allStatuses: "All Statuses",
      city: "City",
      cityPlaceholder: "Enter city",
      price: "Price",
      minPrice: "Minimum Price",
      minPricePlaceholder: "From",
      maxPrice: "Maximum Price",
      maxPricePlaceholder: "To",
      area: "Area",
      minArea: "Minimum Area",
      minAreaPlaceholder: "From",
      maxArea: "Maximum Area",
      maxAreaPlaceholder: "To",
      rooms: "Rooms",
      minRooms: "Minimum Rooms",
      minRoomsPlaceholder: "From",
      maxRooms: "Maximum Rooms",
      maxRoomsPlaceholder: "To",
      sorting: "Sorting",
      sortBy: "Sort By",
      sortByPlaceholder: "Select field",
      sortByPrice: "Price",
      sortByDate: "Date",
      sortByArea: "Area",
      sortByRooms: "Rooms",
      sortOrder: "Sort Order",
      sortOrderPlaceholder: "Select order",
      sortOrderAsc: "Ascending",
      sortOrderDesc: "Descending",
      sections: {
        mainFilters: "Main Filters",
        propertyParams: "Property Parameters",
        sorting: "Sorting",
      },
    },
    stats: {
      total: "Total Properties",
      available: "Available",
      occupied: "Occupied",
      maintenance: "Under Maintenance",
    },
    confirmations: {
      delete: {
        title: "Delete Property",
        description:
          "Are you sure you want to delete this property? This action cannot be undone.",
      },
      removeManager: {
        title: "Remove Manager",
        description:
          "Are you sure you want to remove the manager from this property?",
      },
      removeOwner: {
        title: "Remove Owner",
        description:
          "Are you sure you want to remove the owner from this property?",
      },
      deleteImage: {
        title: "Delete Image",
        description:
          "Are you sure you want to delete this image? This action cannot be undone.",
      },
    },
    dialog: {
      create: {
        title: "Create New Property",
        submit: "Create Property",
        description: "Fill in the property details below",
      },
      assignManager: {
        selectManager: "Select manager",
      },
      assignOwner: {
        selectOwner: "Select owner",
      },
    },
    toast: {
      createSuccess: {
        title: "Property Created",
        description: "Property has been successfully created",
      },
      createError: {
        title: "Error",
        description: "Failed to create property",
      },
      updateSuccess: {
        title: "Property Updated",
        description: "Property has been successfully updated",
      },
      updateError: {
        title: "Error",
        description: "Failed to update property",
      },
      deleteSuccess: {
        title: "Property Deleted",
        description: "Property has been successfully deleted",
      },
      deleteError: {
        title: "Error",
        description: "Failed to delete property",
      },
      cancelEdit: {
        title: "Changes Cancelled",
        description: "All changes have been discarded",
      },
    },
    share: {
      copyLink: "Copy link",
      email: "Share via email",
      messenger: "Share via Messenger",
      success: "Success",
      error: "Error",
      linkCopied: "Link copied to clipboard",
      copyError: "Failed to copy link",
    },
  },
  errors: {
    loadManagersError: "Error loading managers list",
    noManagersAvailable: "No managers available",
  },
  leases: {
    title: "Lease Agreements",
    description: "Manage property lease agreements and contracts",
    create: {
      title: "Create Lease Agreement",
      description: "Create a new lease agreement",
      success: "Lease agreement has been successfully created",
      error: "Failed to create lease agreement",
      button: "Create Lease",
    },
    edit: {
      title: "Edit Lease Agreement",
      description: "Modify existing lease agreement",
      success: "Lease agreement has been successfully updated",
      error: "Failed to update lease agreement",
    },
    view: {
      title: "Lease Agreement",
      description: "View lease agreement details",
    },
    update: {
      success: "Lease agreement has been successfully updated",
      error: "Failed to update lease agreement",
    },
    viewProperty: "View Property",
    viewTenant: "View Tenant",
    noTenant: "No tenant assigned",
    noManager: "No manager assigned",
    startDate: "Start Date",
    endDate: "End Date",
    deposit: "Deposit",
    paymentDay: "Payment day",
    delete: {
      title: "Delete Lease Agreement",
      description:
        "Are you sure you want to delete this lease agreement? This action cannot be undone.",
    },
    noData: {
      title: "No Lease Agreements Found",
      description: "You don't have any lease agreements yet",
      hint: "Add your first lease agreement to start managing your rentals",
    },
    actions: {
      addLease: "Add Lease Agreement",
    },
    filters: {
      title: "Filters",
      status: "Status",
      statusPlaceholder: "Select status",
      property: "Property",
      propertyPlaceholder: "Select property",
      tenant: "Tenant",
      tenantPlaceholder: "Select tenant",
      manager: "Manager",
      managerPlaceholder: "Select manager",
      owner: "Owner",
      ownerPlaceholder: "Select owner",
      searchPlaceholder: "Search by property or tenant name",
      rent: "Monthly Rent",
      minRentPlaceholder: "Min amount",
      maxRentPlaceholder: "Max amount",
      sections: {
        mainFilters: "Main Filters",
        rentFilters: "Rent Filters",
      },
    },
    daysLeft: "{{days}} days left",
    expired: "Expired",
    expiresIn: "Expires in {{days}} days",
    expiredAgo: "Expired {{time}} ago",
    autoRenew: "Auto-renew",
    lastStatusChange: "Status changed",
    details: {
      title: "Lease Details",
      id: "Agreement ID",
      changeStatus: "Change Status",
      property: "Property",
      tenant: "Tenant",
      leaseInfo: "Lease Information",
      period: "Lease Period",
      payment: "Payment Details",
      options: "Lease Options",
      month: "month",
      autoRenew: "Auto Renewal",
      remaining: "{{time}} remaining",
      expired: "Expired {{time}}",
      monthlyRent: "Monthly Rent",
      deposit: "Security Deposit",
      actions: "Actions",
      startDate: "Start Date",
      endDate: "End Date",
      paymentDay: "Payment Day",
      tabs: {
        details: "Details",
      },
    },
    status: {
      ACTIVE: "Active",
      COMPLETED: "Completed",
      CANCELED: "Canceled",
      PENDING: "Pending",
    },
    confirmDelete: "Are you sure you want to delete this lease agreement?",
    table: {
      title: "Lease Agreements",
      description: "Manage all property lease agreements",
      tenant: "Tenant",
      columns: {
        property: "Property",
        tenant: "Tenant",
        manager: "Manager",
        dates: "Lease Period",
        rent: "Rent",
        status: "Status",
        actions: "Actions",
      },
    },
    notifications: {
      created: {
        title: "Lease Created",
        description: "New lease agreement has been successfully created",
      },
      updated: {
        title: "Lease Updated",
        description: "Lease agreement has been successfully updated",
      },
      deleted: {
        title: "Lease Deleted",
        description: "Lease agreement has been successfully deleted",
      },
      statusUpdated: {
        title: "Status Updated",
        description: "Lease status has been successfully updated",
      },
      error: {
        title: "Error",
        description: "An error occurred. Please try again.",
      },
    },
    form: {
      createLease: "Create Lease Agreement",
      editLease: "Edit Lease Agreement",
      property: "Property",
      propertySection: "Property Information",
      selectProperty: "Select property",
      tenant: "Tenant",
      tenantSection: "Tenant Information",
      selectTenant: "Select tenant",
      manager: "Manager",
      managerPlaceholder: "Select manager",
      startDate: "Start Date",
      durationSection: "Lease Duration",
      endDate: "End Date",
      pickDate: "Pick a date",
      endDateOptional: "Optional. Leave empty for indefinite lease",
      monthlyRent: "Monthly Rent",
      deposit: "Security Deposit",
      depositOptional: "Optional. Leave empty if no deposit required",
      paymentDay: "Payment Day",
      status: "Status",
      statusSection: "Lease Status",
      selectStatus: "Select status",
      autoRenew: "Auto Renewal",
      autoRenewDescription: "Automatically renew the lease when it expires",
      financialSection: "Financial Details",
      notes: "Notes",
      notesSection: "Additional Notes",
      notesPlaceholder: "Enter additional notes about this lease agreement",
      notesDescription: "Any additional information about the lease agreement",
      validation: {
        propertyRequired: "Property is required",
        tenantRequired: "Tenant is required",
        managerRequired: "Manager is required",
        startDateRequired: "Start date is required",
        endDateRequired: "End date is required",
        rentRequired: "Monthly rent is required",
        depositRequired: "Security deposit is required",
        paymentDayRequired: "Payment day is required",
        endDateAfterStart: "End date must be after start date",
        rentPositive: "Monthly rent must be greater than 0",
        depositPositive: "Security deposit must be greater than 0",
        paymentDayRange: "Payment day must be between 1 and 31",
      },
    },
  },
  systemSettings: {
    title: "System Settings",
    description: "Manage system settings and configurations",
    tabs: {
      featureToggles: "Feature Toggles",
      general: "General",
    },
    featureToggles: {
      title: "Feature Toggles Management",
      description: "Enable or disable system features.",
      systemMode: "System Mode",
      toggleSystemMode: "Toggle system mode",
      search: {
        placeholder: "Search by key or description...",
        ariaLabel: "Search feature toggles"
      },
      filters: {
        title: "Filters",
        status: "Status Filter",
        showEnabled: "Show enabled",
        showDisabled: "Show disabled",
        all: "All",
        reset: "Reset Filters",
        resetAll: "Reset All Filters",
        showing: "Showing",
        hidden: "Hidden"
      },
      status: {
        enabled: "Enabled",
        disabled: "Disabled"
      },
      enable: "Enable {key}",
      disable: "Disable {key}",
      noDescription: "No description provided",
      orderLabel: "Order: {order}",
      orderDescription: "The order determines how the toggle appears in the UI",
      updatedBy: "by {author}",
      dragToReorder: "Drag to reorder",
      noToggles: {
        title: "No Feature Toggles Found",
        description: "There are no feature toggles available or matching your filters"
      },
      count: {
        all: "{count} toggles",
        filtered: "Showing {filtered} of {total} toggles"
      },
      errors: {
        loadError: {
          title: "Failed to load feature toggles",
          description: "Could not load feature toggles. Please try again later."
        },
        reorder: "Failed to reorder feature toggles",
        update: "Failed to update feature toggle"
      },
      toast: {
        updateSuccess: {
          title: "Toggle Updated",
          description: "Feature toggle has been successfully updated"
        },
        updateError: {
          title: "Update Failed",
          description: "Failed to update feature toggle status"
        },
        orderSuccess: {
          title: "Order Updated",
          description: "Feature toggle order has been successfully updated"
        },
        orderError: {
          title: "Reorder Failed",
          description: "Failed to update feature toggle order"
        }
      }
    },
    general: {
      title: "General Settings",
      description: "Manage general system settings",
    },
  },
};

export default translations;
